import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components/misc'

import { Z_INDEX } from 'interfaces/constants'

export const StyledMorePopup = styled.div`
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06),
    0px 0px 1px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  position: absolute;
  top: 56px;
  right: 16px;
  z-index: ${Z_INDEX.adBlock};
  background-color: ${theme.colors.white};

  &:before {
    content: '';
    position: absolute;
    top: -10px;
    right: 8px;
    width: 0px;
    height: 0px;
    border: 5px solid transparent;
    border-bottom-color: ${theme.colors.white};
  }

  img {
    width: 18px;
    height: 18px;
  }

  .share-group {
    margin-top: 16px;
  }
`

export const StyledMoreOption = styled.div`
  display: flex;
  gap: 8px;
  padding: 12px 24px;
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.gray100};
  }
`
